<template>
  <section id="main-content">
    <div class="container-fluid" id="currentRow">
      <h2 class="fw-bold text-muted">Free Resources</h2>
      <!-- SP: Current LMI -->

      <carousel-row :reports="reports['program guides']" v-if="reports['program guides']" category="Program Guides"
        abbr="program-guides" current="Current" :searchFilter="searchFilter" />
      <carousel-row :reports="reports['ebooks']" v-if="reports['ebooks']" category="eBooks" abbr="ebooks"
        current="Current" :searchFilter="searchFilter" />
      <carousel-row :reports="reports['brochures']" v-if="reports['brochures']" category="Brochures" abbr="brochures"
        current="Current" :searchFilter="searchFilter" />
      <carousel-row :reports="reports['toolkits']" v-if="reports['toolkits']" category="Toolkits" abbr="toolkits"
        current="Current" :searchFilter="searchFilter" />
    </div>
  </section>
</template>

<script>
// import "bootstrap";

import '../assets/_globals.scss';
import '../assets/style.scss';
import CarouselRow from './CarouselRow';

export default {
  name: "FreeResources",
  components: {
    CarouselRow,
  },
  data() {
    return {
      reports: { ebooks: [], brochures: [], "program guides": [], "toolkits": [] },

      loading: false,
      categoryFilter: ["Brochures", "eBooks", "Program Guides", "Toolkits"],
      statusFilter: ["Current", "Archive"],
      searchFilter: "",
    };
  },
  mounted() {
    let vm = this;
    vm.loading = true;
    fetch(
      "https://eco.ca/wp-content/themes/hello-theme-child-master/resources_api.php"
    )
      .then((response) => response.json())
      .then((data) => {
        // data = data.reverse();
        for (var report in data) {
          if (
            vm.reports[data[report].post_category.toLowerCase()] === undefined
          ) {
            vm.reports[data[report].post_category.toLowerCase()] = [];
          }
          if (data[report].post_category.toLowerCase() != "videos") {
            data[report]["cover-page-image"] = data[report].cover;
            if (!data[report]["post_excerpt"])
              data[report]["post_excerpt"] = data[report].post_content
                .replace(/(<([^>]+)>)/gi, "")
                .substr(0, 250);
            data[report]["post_excerpt"] += "...";
            vm.reports[data[report].post_category.toLowerCase()].push(
              data[report]
            );
          }
        }
        vm.reports["ebooks"] = vm.reports["ebooks"].reverse();
        vm.reports["brochures"] = vm.reports["brochures"].reverse();
        vm.reports["program guides"] = vm.reports["program guides"].reverse();
        vm.reports["toolkits"] = vm.reports["toolkits"].reverse();

        console.log(vm.reports);
        vm.loading = false;
      })
      .catch((err) => {
        console.error(err);
        vm.loading = false;
      });
  },
};
</script>
